export default __webpack_public_path__ + "static/media/landing-mobile-04.f4fe5f6d.png";